import { CART_FIELDS } from './shopifyFragments';

export const CREATE_CART_QUERY = `
  mutation CreateCart($lines: [CartLineInput!], $country: CountryCode) @inContext(country: $country) {
    cartCreate(input: { lines: $lines }) {
      cart {
        ${CART_FIELDS}
      }
    }
  }
`;

export const FETCH_CART_QUERY = `
  query FetchCart($cartId: ID!, $country: CountryCode) @inContext(country: $country) {
    cart(id: $cartId) {
      ${CART_FIELDS}
    }
  }
`;

export const MODIFY_CART_MUTATIONS = {
  add: `
    mutation AddToCart($cartId: ID!, $lines: [CartLineInput!]!, $country: CountryCode) @inContext(country: $country) {
      cartLinesAdd(cartId: $cartId, lines: $lines) {
        cart {
          ${CART_FIELDS}
        }
      }
    }
  `,
  update: `
    mutation UpdateCart($cartId: ID!, $lines: [CartLineUpdateInput!]!, $country: CountryCode) @inContext(country: $country) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          ${CART_FIELDS}
        }
      }
    }
  `,
  remove: `
    mutation RemoveFromCart($cartId: ID!, $lineIds: [ID!]!, $country: CountryCode) @inContext(country: $country) {
      cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
        cart {
          ${CART_FIELDS}
        }
      }
    }
  `,
};

export const APPLY_CART_DISCOUNT_CODES = `
  mutation ApplyCartDiscountCodes($cartId: ID!, $discountCodes: [String!]!, $country: CountryCode)
  @inContext(country: $country) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      cart {
        ${CART_FIELDS}
      }
      userErrors {
        field
        message
        code
      }
    }
  }
`;
